import {
  IUserAuth,
  PermissionsService,
  IExternalData,
  LGEDataService,
  IFormConfiguration,
  ILogin,
} from '../../../commons';
import {
  Login,
  LoginNavigate,
  LoginSuccess,
  LoginFailure,
  AuthenticationRedirect,
  LoadAuthenticationState,
  LoadAuthenticationStateSuccess,
  LoadAuthenticationStateFail,
  AuthenticationActionTypes,
  LoadExternalProfileStateSuccess,
  LoadFormConfigStateSuccess,
  LoadFormOrProfileStateFail,
  LoadFormConfigState,
  LoginRedirect,
} from './login.actions';
import { Router } from '@angular/router';
import { from, of } from 'rxjs';
import {
  catchError,
  exhaustMap,
  map,
  startWith,
  switchMap,
  tap,
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { AuthenticationService } from 'src/commons/services/auth.service';
import { AppStorageService } from 'src/commons/services/storage.service';

@Injectable()
export class AuthenticationEffects {
  constructor(
    private actions$: Actions,
    private _router: Router,
    private authService: AuthenticationService,
    private lgeData: LGEDataService
  ) {}
  loadFormConfigState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthenticationActionTypes.LoadFormConfigState),
      exhaustMap(() =>
        from(this.lgeData.GetFormConfigs()).pipe(
          map(
            (formConfigs: IFormConfiguration[]) =>
              new LoadFormConfigStateSuccess(formConfigs)
          ),
          catchError((error: Error) =>
            of(new LoadFormOrProfileStateFail(error))
          )
        )
      )
    )
  );

  login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthenticationActionTypes.Login),
      map((action: Login) => action.extLogin),
      exhaustMap((auth: ILogin) =>
        from(this.authService.authenticateUser(auth)).pipe(
          map((user: IUserAuth) => new LoginSuccess(user)),
          catchError((error: Error) => of(new LoginFailure(error)))
        )
      )
    );
  });

  loginSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthenticationActionTypes.LoginSuccess),
      map((action: LoginSuccess) => action.payload),
      exhaustMap((user: IUserAuth) => {
        return this.authService.checkAuthentication(user).pipe(
          map(() => new AuthenticationRedirect()),
          catchError((error: Error) =>
            of(new LoadAuthenticationStateFail(error))
          )
        );
      })
    )
  );

  loginRedirect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthenticationActionTypes.LoginRedirect),
        switchMap((user) => {
          // if (this.isLogOut) {
          //     return this.db.executeWrite('authentication', 'delete', [this.user.id || '1'])
          //         .do(() => this.router.navigate(['/login']))
          //         .catch(error => Observable.of(new LoginFailure(error)));
          // } else
          {
            return this._router.navigate(['/login']);
          }
        })
      ),
    { dispatch: false }
  );

  loadExternalProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthenticationActionTypes.LoadExternalProfileState),
      switchMap(() =>
        from(
          this.lgeData.getExternalUserByEmail(
            this.authService.getSession().userId
          )
        ).pipe(
          map((externalProfile: IExternalData) => {
            return new LoadExternalProfileStateSuccess(externalProfile[0]);
          }),
          catchError((error) => of(new LoadFormOrProfileStateFail(error)))
        )
      )
    )
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthenticationActionTypes.Logout),
        tap(() => {
          this.authService.removeSession();
          this._router.navigate(['/login']);
        })
      ),
    { dispatch: false }
  );

  loadAuthenticationState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthenticationActionTypes.LoadAuthenticationState),
      startWith(new LoadAuthenticationState()),
      switchMap(() =>
        of(this.authService.getSession()).pipe(
          map((_auth: IUserAuth) => new LoadAuthenticationStateSuccess(_auth)),
          catchError((error: Error) =>
            of(new LoadAuthenticationStateFail(error))
          )
        )
      )
    )
  );

  loadAuthenticationStateSucces$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthenticationActionTypes.LoadAuthenticationStateSuccess),
      map((action: LoadAuthenticationStateSuccess) => action.payload),
      exhaustMap((user: IUserAuth) => {
        return this.authService.checkAuthentication(user).pipe(
          map(() => new AuthenticationRedirect()),
          catchError((error: Error) =>
            of(new LoadAuthenticationStateFail(error))
          )
        );
      })
    );
  });

  authenticationRedirect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthenticationActionTypes.AuthenticationRedirect),
        tap(() => this._router.navigate(['/home']))
      ),
    {
      dispatch: false,
    }
  );
}
